import React from "react";

import Text from "src/components/text";

import styles from "./contentListCard.module.scss";
import { LeadsContentItem } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

interface LeadsContentListItemProps {
  item: LeadsContentItem;
  columnCount: number;
}

const LeadsContentListItem: React.FC<LeadsContentListItemProps> = ({
  item,
  columnCount,
}) => {
  const { name, icon, shares, leads, createdDate, id } = item;

  return (
    <div key={id} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={icon?.thumbnail || DefaultAssetIcon}
          alt={name}
          className={styles.thumbnailIcon}
        />
        <a
          href={`/assets/${id}?source=reports`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text text={name || ""} className={styles.content} lines={1} />
            </div>
            <span className={styles.metricsData}>
              Added:{" "}
              {new Date(createdDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </span>
          </div>
        </a>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{shares}</div>
        <div className={styles.tableDataShares}>{leads}</div>
      </div>
    </div>
  );
};

export default LeadsContentListItem;
